import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';

export const BrandList = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        showMore(event){
            let link = $(event.target);

            if(link.hasClass('js-catalog-brands-show-text')){
                link = link.closest('.js-catalog-brands-show');
            }

            if (!link.hasClass('is-show')) {
                link.addClass('is-show');
                link.find('.js-catalog-brands-show-text').text('Свернуть');
                $(this.$el).find('.js-catalog-brands-list').addClass('is-show');
              } else {
                link.removeClass('is-show');
                link.find('.js-catalog-brands-show-text').text('Развернуть');
                $(this.$el).find('.js-catalog-brands-list').removeClass('is-show');
              }
        }
    },
    updated(){

    },
    mounted(){
        if ($(window).width() < 768) {
            if ($(this.$el).find('.js-catalog-brands-item').length > 4) {
              $(this.$el).find('.js-catalog-brands-show').addClass('is-active');
            } else {
              $(this.$el).find('.js-catalog-brands-show').removeClass('is-active');
            }
          } else {
            if ($(this.$el).find('.js-catalog-brands-item').length > 8) {
              $(this.$el).find('.js-catalog-brands-show').addClass('is-active');
            } else {
              $(this.$el).find('.js-catalog-brands-show').removeClass('is-active');
            }
          }
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        getBrands(){
            let arItems = {};
            for(let i in this.struct[this.structKey].CHILDS){
                if(this.struct[this.structKey].CHILDS[i].componentData.VUE_COMPONENT == 'BrandList'){
                    arItems = this.struct[this.structKey].CHILDS[i].componentData.ITEMS;
                }
            }
            return arItems;
        }
    },
    template: `
    <div v-if="Object.keys(getBrands).length" class="catalog__brands-wp">
        <div class="catalog__brands-title">Бренды из этой категории</div>
        <div class="catalog__brands-list js-catalog-brands-list">


            <a v-for="item in getBrands" :href="item.LINK" class="catalog__brands-item js-catalog-brands-item">
                <div class="catalog__brands-logo" :class="{'no-photo': item.IMAGE === false}">
                    <img v-if="item.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE" :alt="item.NAME" :title="item.NAME">
                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
                </div>
                <div class="catalog__brands-info">
                    <div class="catalog__brands-name">{{item.NAME}}</div>
                    <img v-if="item.FLAG !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.FLAG" :alt="item.NAME" :title="item.NAME">
                </div>
            </a>


        </div>
        <a href="#" class="catalog__brands-show js-catalog-brands-show" @click.prevent="showMore($event)">
            <span class="js-catalog-brands-show-text">Развернуть</span>
            <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
        </a>
    </div>
    `
}